<template>
    <div v-loading.fullscreen.lock="loading">
        <div class="place_order">
            <div class="place_order_left">
                <div class="place_order_left_card">
                    <div class="place_order_title place_order_title_btn">
                            <div>托运人信息</div>
                            <el-button type="primary" @click="startAddressVisible = true">从地址薄中选择</el-button>
                        </div>
                        <div class="place_order_left_card_form">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <div class="place_order_input" @click="startAddressVisible = true">
                                        <span class="place_order_input_value" v-if="startAddress.contacts_name">{{startAddress.contacts_name}}</span>
                                        <span class="place_order_input_placeholder" v-else>请填写托运人姓名或公司名称</span>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="place_order_input" @click="startAddressVisible = true">
                                        <span class="place_order_input_value" v-if="startAddress.contacts_phone">{{startAddress.contacts_phone}}</span>
                                        <span class="place_order_input_placeholder" v-else>请填写托运人手机号码</span>
                                    </div>
                                    <!-- <el-input v-model="form.name" placeholder="请填写托运人手机号码"></el-input> -->
                                </el-col>
                            </el-row>
                            <!-- <el-row :gutter="20">
                                <el-col :span="12">
                                    <div class="place_order_input" @click="startAddressVisible = true">
                                        <span class="place_order_input_value" v-if="startAddress.province">{{startAddress.province}}{{startAddress.city}}{{startAddress.district}}</span>
                                        <span class="place_order_input_placeholder" v-else>请选择托运人的城市</span>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="place_order_input" @click="startAddressVisible = true">
                                        <span class="place_order_input_value" v-if="startAddress.owner_name">{{startAddress.owner_name}}</span>
                                        <span class="place_order_input_placeholder" v-else>请填写公司名称（选填）</span>
                                    </div>
                                </el-col>
                            </el-row> -->
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <div class="place_order_input" @click="startAddressVisible = true">
                                        <span class="place_order_input_value" v-if="startAddress.detalied_address">{{startAddress.detalied_address}}</span>
                                        <span class="place_order_input_placeholder" v-else>请填写详细地址</span>
                                    </div>
                                    <!-- <el-input v-model="startAddressData.address" placeholder="请填写详细地址"></el-input> -->
                                </el-col>
                            </el-row>
                        </div>
                </div>
                <div class="place_order_left_card" style="margin-top:24px">
                    <div class="place_order_title  place_order_title_btn">
                            <div>收件人信息</div>
                            <el-button type="primary" @click="endAddressVisible = true">从地址薄中选择</el-button>
                        </div>
                        <div class="place_order_left_card_form">
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <div class="place_order_input" @click="startAddressVisible = true">
                                        <span class="place_order_input_value" v-if="endAddress.province">{{endAddress.province}}{{endAddress.city}}{{endAddress.district}}</span>
                                        <span class="place_order_input_placeholder" v-else>请选择收件人的城市</span>
                                    </div>
                                    <!-- <mapSelectAddress :disabled="true" :placeholder="'请选择收件人的城市'" @selectMap="selectEndMap"></mapSelectAddress> -->
                                </el-col>
                                <el-col :span="12">
                                    <div class="place_order_input" @click="endAddressVisible = true">
                                        <span class="place_order_input_value" v-if="endAddress.owner_name">{{endAddress.owner_name}}</span>
                                        <span class="place_order_input_placeholder" v-else>请填写公司名称（选填）</span>
                                    </div>
                                    <!-- <el-input v-model="form.name" placeholder="请填写公司名称（选填）"></el-input> -->
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="24">
                                    <!-- <el-input v-model="endAddressData.address" placeholder="请填写详细地址"></el-input> -->
                                    <div class="place_order_input" @click="endAddressVisible = true">
                                        <span class="place_order_input_value" v-if="endAddress.detalied_address">{{endAddress.detalied_address}}</span>
                                        <span class="place_order_input_placeholder" v-else>请填写详细地址</span>
                                    </div>
                                </el-col>
                            </el-row>
                        </div>
                </div>
                <div class="place_order_left_card" style="margin-top:24px">
                    <div class="place_order_title">
                            <div>托运信息</div>
                        </div>
                        <div class="place_order_left_card_form" style="padding-bottom:6px">
                            <el-form label-width="180px" label-position="left">
                                <el-form-item label="增值服务" style="margin-top:20px">
                                    <el-checkbox-group @change="getDebouncePrice" v-model="form.added_service" class="place_order_left_card_form_checkbox">
                                        <el-checkbox v-for="item in servicesTypeList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-form>
                        </div>
                </div>
                <div class="place_order_left_card" style="margin-top:24px">
                    <div class="place_order_title">
                            <div>结算类型</div>
                        </div>
                        <div class="place_order_left_card_form" style="padding-bottom:6px">
                            <el-form label-width="180px" label-position="left">
                                <el-form-item label="结算类型" style="margin-top:20px">
                                    <el-radio-group v-model="form.settlement_type" class="place_order_left_card_form_checkbox">
                                        <el-radio v-for="item in settlementTypeList" :label="item.id" :key="item.id">{{item.name}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-form>
                        </div>
                </div>
                <div class="place_order_left_card" style="margin-top:24px">
                    <div class="place_order_title">
                            <div>车辆信息</div>
                        </div>
                        <div class="place_order_left_card_form" style="padding-bottom:6px">
                            <el-form label-width="180px" label-position="left">
                                <el-form-item label="装卸方式" style="margin-top:20px">
                                    <el-radio-group v-model="form.vehicle_mode" @change="getDebouncePrice" class="place_order_left_card_form_checkbox">
                                        <el-radio style="width:160px" v-for="item in vehicleModeList" :label="item" :key="item">{{item}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="车辆长度" style="margin-top:20px">
                                    <el-radio-group v-model="form.vehicle_length" @change="getDebouncePrice" class="place_order_left_card_form_checkbox">
                                        <el-radio  style="width:66px" v-for="item in vehicleLengthList" :label="item" :key="item.id">{{item}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="车型" style="margin-top:20px">
                                    <el-checkbox-group :max="3" style="width:460px;position:relative;left:-60px" @change="getDebouncePrice" v-model="form.vehicle_model_number" class="place_order_left_card_form_checkbox">
                                        <el-checkbox style="width:80px" v-for="item in vehicleTypeList" :label="item" :key="item">{{item}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                            </el-form>
                        </div>
                </div>
            </div>
            <div class="place_order_right">
                <div class="place_order_right_card">
                    <div class="place_order_title">
                            <div>物品信息</div>
                        </div>
                        <div class="place_order_right_card_form" style="padding-bottom:6px">
                            <el-form label-width="180px" label-position="left">
                                <el-form-item label="物品类型" style="margin-top:20px">
                                    <el-radio-group v-model="form.goods_type" @change="getDebouncePrice" class="place_order_left_card_form_checkbox">
                                        <el-radio v-for="item in goodsTypeList" :label="item.id" :key="item.id">{{item.name}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <el-form-item label="包装类型" style="margin-top:20px">
                                    <!-- @change="getDebouncePrice" -->
                                    <!-- <el-radio-group v-model="form.pack_type"  class="piece_order_left_card_form_checkbox">
                                        <el-radio v-for="item in packTypeList" :label="item.id" :key="item.id">{{item.name}}</el-radio>
                                    </el-radio-group> -->
                                    <el-checkbox-group @change="getDebouncePrice" v-model="form.pack_type" class="place_order_left_card_form_checkbox">
                                        <el-checkbox v-for="item in packTypeList" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item label="物品数量" style="margin-top:20px" class="place_order_right_card_form_num">
                                    <div style="position:relative;padding-left:180px">
                                        <el-input-number v-model="form.goods_num" @change="getDebouncePrice" :min="1" :max="9999"></el-input-number>
                                        <div class="place_order_right_card_form_num_unit">件</div>
                                    </div>
                                    
                                </el-form-item>
                                <el-form-item label="重量" style="margin-top:20px">
                                    <div style="position:relative;padding-left:180px" class="place_order_right_card_form_num">
                                        <el-input-number v-model="form.goods_weight" @change="getDebouncePrice" :min="1" :max="99999"></el-input-number>
                                        <div class="place_order_right_card_form_num_unit">吨</div>
                                    </div>
                                </el-form-item>
                                <el-form-item label="体积" style="margin-top:20px" class="place_order_right_card_form_num">
                                    <div style="position:relative;padding-left:180px">
                                        <el-input-number v-model="form.goods_volume" @change="getDebouncePrice" :min="1" :max="99999"></el-input-number>
                                        <div class="place_order_right_card_form_num_unit place_order_right_card_form_num_lifang">m³</div>
                                    </div>
                                </el-form-item>
                                <div class="place_order_right_card_form_title">物品照片与备注（非必填）</div>
                                <div class="place_order_right_card_form_imgList">
                                    <div class="place_order_right_card_form_imgList_item" v-if="form.goods_image.length < 3">
                                        <uploadImage :img="img" @imgUpload="imgUpload"></uploadImage>
                                    </div>
                                    <div class="place_order_right_card_form_imgList_img" @mouseover="selectIconIndex = index" @mouseleave="selectIconIndex = -1" v-for="(imgItem,index) in form.goods_image" :key="index">
                                        <img style="cursor: pointer;" @click.stop="showImg(index)" :src="$imgUrl + imgItem" alt="">
                                        <img v-if="index != selectIconIndex" class="place_order_right_card_form_imgList_img_icon1" src="../../assets/img_done.png" alt="">
                                        <img v-else class="place_order_right_card_form_imgList_img_icon1" @click="deleteImg(index)" src="../../assets/img_delete.png" alt="">
                                    </div>
                                </div>
                                <div style="margin-top:16px;margin-bottom:20px">
                                    <el-input v-model="form.remark" style="font-size:18px" type="textarea" rows="3" show-word-limit maxlength="100" resize="none" placeholder="请填写备注信息"></el-input>
                                </div>
                            </el-form>
                        </div>
                </div>
                <div class="place_order_right_card" style="margin-top:20px">
                    <div class="place_order_title">
                            <div>费用明细</div>
                        </div>
                        <div class="place_order_right_card_list">
                            <div class="place_order_right_card_list_item">
                                <div class="place_order_right_card_list_item_title">运费</div>
                                <div class="place_order_right_card_list_item_num" v-if="priceData.base_price">¥{{priceData.base_price}}</div>
                            </div>
                            <div class="place_order_right_card_list_item">
                                <div class="place_order_right_card_list_item_title">到付运费(返还)</div>
                                <div class="place_order_right_card_list_item_num">
                                    <el-input @input="getDebouncePrice" v-model="priceData.rebate_price" placeholder="请输入到付运费" class="place_order_right_card_list_item_input">
                                        <template slot="append">元</template>
                                    </el-input>
                                    <!-- ¥{{priceData.rebate_price}} -->
                                </div>
                            </div>
                            
                            <div class="place_order_right_card_list_item">
                                <div class="place_order_right_card_list_item_title">物品价值</div>
                                <div class="place_order_right_card_list_item_num">
                                    <el-input @input="getDebouncePrice" v-model="priceData.goods_value" placeholder="请输入物品价值" class="place_order_right_card_list_item_input">
                                        <template slot="append">元</template>
                                    </el-input>
                                </div>
                            </div>
                            <div class="place_order_right_card_list_item">
                                <div class="place_order_right_card_list_item_title">保价</div>
                                <div class="place_order_right_card_list_item_num" v-if="priceData.insured_price">¥{{priceData.insured_price}}</div>
                            </div>
                            <div class="place_order_right_card_list_item">
                                <div class="place_order_right_card_list_item_title">增值服务费</div>
                                <div class="place_order_right_card_list_item_num" v-if="priceData.added_service_price">¥{{priceData.added_service_price}}</div>
                            </div>
                            <!-- <div class="place_order_right_card_list_item">
                                <div class="place_order_right_card_list_item_title">优惠券</div>
                                <div class="place_order_right_card_list_item_num">
                                    <span class="place_order_right_card_list_item_num_coupon" @click="selectCoupon">选择优惠券</span>
                                    <span v-if="couponData.reduce">¥{{couponData.reduce}}</span>
                                </div>
                            </div> -->
                        </div>
                        <div class="place_order_right_card_total">
                            <div class="place_order_right_card_total_settlement">
                                <div>总计</div>
                                <div v-if="priceData.total_price">¥{{priceData.total_price}}</div>
                            </div>
                            <div class="place_order_right_card_total_btn">
                                <el-button type="primary"  @click="submit">立即下单</el-button>
                            </div>
                            
                        </div>
                </div>
            </div>
        </div>
         <el-image-viewer
	         v-if="showViewer"
	         :on-close="()=>{showViewer=false}"
	         :url-list="imgPreviewList" />
         <coupon v-if="couponVisible" :couponVisible.sync="couponVisible" :couponId="form.coupon_id" :couponCallback="couponCallback"></coupon>
         <start-address v-if="startAddressVisible" :startAddressVisible.sync="startAddressVisible" :startCallback="startCallback"></start-address>
         <end-address v-if="endAddressVisible" :endAddressVisible.sync="endAddressVisible" :endCallback="endCallback"></end-address>
         <order-success  v-if="orderSuccessVisible" :orderSuccessVisible.sync="orderSuccessVisible"></order-success>
    </div>
   
   
</template>

<script>
import mapSelectAddress from '../../components/mapSelectAddress'
import uploadImage from '../../components/uplaodImage'
import coupon from './components/coupon'
import StartAddress from './components/startAddress.vue'
import EndAddress from './components/endAddress.vue'
import OrderSuccess from './components/orderSuccess.vue'
import debounce from 'lodash.debounce'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
   data (){
       return {
           img:require('../../assets/upload.png'),
           form:{
               delivery_type:1,
               added_service:[],
               num:1,
               vehicle_model_number:[],
               vehicle_mode:'',
               goods_type:'',
               vehicle_length:'',
               goods_num:1,
               goods_weight:1,
               goods_volume:1,
               goods_value:0,
               goods_image:[],
               coupon_id:'',
               settlement_type:0,
               pack_type:[]
           },
           settlementTypeList:[{id:0,name:'寄付现结'},{id:1,name:'货到付款'}],//结算类型数组
           loading:false,
           vehicleModeList:[],//装卸方式列表
           vehicleLengthList:[
               
           ],//车长列表
           vehicleTypeList:[],
           mapVisible:false,
           optionsList:[],
           startAddressData:{
               lng:null,
               lat:null,
               city:'',
               address:''
           },
           endAddressData:{
               lng:null,
               lat:null,
               city:'',
               address:''
           },
           packTypeList:[],
           imgList:[],
           goodsTypeList:[],
           servicesTypeList:[],
           selectIconIndex:-1,//获取删除图片的index
           serviceList:[],
           couponVisible:false,
           startAddress:{},
           endAddress:{},
           startAddressVisible:false,
           endAddressVisible:false,
           couponData:{},
           priceData:{},
           orderSuccessVisible:false,
           imgPreviewList:[],
           showViewer:false,
           previewIndex:0
       }
   },
   components: {
       mapSelectAddress,
       uploadImage,
       coupon,
       StartAddress,
       EndAddress,
       OrderSuccess,
       ElImageViewer
   },
   watch: {
    
         
   },
   computed: { 
       
   },
   methods: {
       showImg(index){
           
           let imgList = [];
        //    _.each(this.form.goods_image , item => {
        //        imgList.push(this.$imgUrl + item);
        //    });
           for(let i = 0 ; i < this.form.goods_image.length ; i++){
               if(index + i < this.form.goods_image.length){
                   imgList.push(this.$imgUrl + this.form.goods_image[index + i]);
               }else{
                   imgList.push(this.$imgUrl + this.form.goods_image[i - index - 1]);
               }
               
           }
           this.imgPreviewList = imgList;
           this.previewIndex = index;
           this.showViewer = true;
       },
       upload(file){
           console.log(file);
       } ,
       imgUpload(data){
           this.form.goods_image.push(data.image_path);
       },
       submit(){
           this.loading = true;
           this.$post('CreateOrder',this.form)
            .then(data => {
                this.$message.success('下单成功！');
                this.orderSuccessVisible = true;
                this.loading = false;
            } , error => {
                this.$message.error(error);
                this.loading = false;
            });
       },
        //选择优惠券    
       selectCoupon(){
           this.couponVisible = true;
       },
    //    选择过优惠券的回调函数
        couponCallback(data){
            this.form.coupon_id = data.id;
            this.couponData = data;
            this.getDebouncePrice();
            this.couponVisible = false;
        },
       handleChange(){
           
       },
    //    选择托运地址后的反填
    startCallback(data){
        console.log(data);
        this.startAddress = data;
        this.form.address_start_id = data.id;
        this.getDebouncePrice();
        this.startAddressVisible = false;
    },
     //    选择收货信息的反填
    endCallback(data){
        console.log(data);
        this.endAddress = data;
        this.form.address_end_id = data.id;
        this.getDebouncePrice();
        this.endAddressVisible = false;
    },
    //    获取车型信息
        getVehicleData(){
            this.$get('VehicleInfo',{})
                .then(data => {
                    this.vehicleModeList = data.mode;
                    this.vehicleLengthList = data.length;
                    this.vehicleTypeList = data.model_number;
                }, error => {
                    this.$message.error(error);
                });

        },
    //    获取物品类型
        getGoodsType(){
            this.$get('GoodsType',{})
                .then(data => {
                    this.goodsTypeList = data;
                } , error => {
                    this.$message.error(error);
                });
        },
        //    获取增值服务类型
        getServicesType(){
            this.$get('AddedService',{type:1})
                .then(data => {
                    this.servicesTypeList = data;
                } , error => {
                    this.$message.error(error);
                });
        },
        
        // 发件人的地址选择   
       selectStartMap(address){
           this.startAddressData = address;
       },
        // 收件人的地址选择
       selectEndMap(address){
           this.endAddressData = address;
       },

        //  获取包装选项
        getPackType(){
            this.$get('PackType',{})
                .then(data => {
                    this.packTypeList = data;
                } , error => {
                    this.$message.error(error);
                });
        },
        init(){
            this.getGoodsType();
            this.getServicesType();
            this.getVehicleData();
            this.getPackType();
        } ,
        // 物品照片删除
        deleteImg(index){
            this.form.goods_image.splice(index,1);
        },
        getPrice(){
            if(this.form.address_start_id && this.form.address_end_id){
                this.form.rebate_price = this.priceData.rebate_price;
                this.form.goods_value = this.priceData.goods_value || 0;
                this.$post('CalculationOrderPrice',this.form)
                    .then(data => {
                        delete data.rebate_price;
                        Object.assign(this.priceData,data);
                        this.$forceUpdate();
                    }, error => {
                        this.$message.error(error);
                    });
            }
            
        },
        getDebouncePrice:debounce(function() {
            this.getPrice();
        }, 1000)
   },
   created() {
       this.init();
    //    this.form = {"delivery_type":1,"added_service":[7,4],coupon_id:'',"num":1,"vehicle_model_number":["平板"],"vehicle_mode":"一装一卸","goods_type":8,"vehicle_length":"1.8m","goods_num":3,"goods_weight":3,"goods_volume":3,"goods_value":0,"goods_image":["logistics/e11f63053165d9db3f297ef4d9f74540.png"],"address_start_id":36,"address_end_id":43};
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.place_order{
    width:1180px;
    display: flex;
    justify-content: space-between;
    margin: 24px calc(50% - 590px) 116px calc(50% - 590px);
    /deep/ .el-form-item{
        margin-bottom:0px;
    }
    /deep/ .el-checkbox__label{
        font-size: 18px;
        font-weight: 400;
        color:#999999;
    }
    /deep/ .el-checkbox__inner{
        width:18px;
        height:18px;
        position: relative;
        top:-1px;
    }
    /deep/ .el-form-item__content{
        line-height: 30px;
    }
    /deep/ .el-checkbox__inner::after{
        height: 9px;
        left:6px;
    }
    // 
    /deep/ .el-radio{
        line-height: 30px;
    }
    /deep/ .el-radio__inner{
        width:18px;
        height:18px;
        font-size: 18px;;
        position: relative;
        top:-1px;
    }
    /deep/ .el-radio__inner::after{
        width:6px;
        height: 6px;
    }
    /deep/ .el-radio__label{
        font-weight: 500;
        font-size: 18px;
        color:#999999;
    }
    /deep/ .el-form-item__label{
        font-size: 18px;
        color:#333;
    }
    /deep/ .el-input__inner{
        // width:260px;
        border-radius: 0;
        height: 42px;
        line-height: 42px;        
    }
    &_input{
        height: 42px;
        font-size: 14px;
        line-height: 42px;
        padding: 0 16px;
        border:1px solid #CFD7E0;
        cursor: pointer;
        &_placeholder{
            color:#A6AEC1;
        }
        &_value{
            color:#606266;
        }
    }
    &_left{
        width:580px;
        &_card{
            background:#fff;
            
            &_form{
                padding: 0 20px 20px 20px;
                &_checkbox{
                    width:390px;
                    margin-top:6px;
                }
            }
            /deep/ .el-row{
                margin-top: 20px;
            }
        }
    }
    &_right{
        width:580px;
        &_card{
            background:#fff;
            &_total{
                margin:0 20px;
                border-top:1px solid #E1E1E1;
                &_settlement{
                    display: flex;
                    justify-content: space-between;
                    font-size: 24px;
                    font-weight: 500;
                    color:#333;
                    line-height: 34px;
                    padding: 16px 0;
                }
            }
            &_list{
                padding: 20px 20px 0px 20px;
                &_item{
                    display: flex;
                    justify-content: space-between;
                    font-size: 18px;
                    line-height: 25px;
                    padding-bottom: 16px;
                    &_title{
                        color:#666;
                    }
                    &_num{
                        color:#333;
                        &_coupon{
                            color:#009AFF;
                            cursor: pointer;
                        }
                    }
                    /deep/ .el-input-group__append{
                        border:none;
                        background: none;
                        font-size: 18px;
                        color:#333;
                        padding: 0 0 0 20px;
                        line-height: 24px;
                    }
                    /deep/ &_input .el-input__inner{
                        width:159px;
                        height: 25px;
                        line-height: 25px;
                        font-size: 18px;
                        border:0;
                        padding-right: 0;
                        text-align: right;
                    } 
                }  
                
            }
            &_form{
                padding: 0 20px 20px 20px;
                &_imgList{
                    display: flex;
                    padding-top:20px;
                    &_item{
                        position: relative;
                        img{
                            width:95px;
                            height: 95px;
                        }
                    }
                    &_img{
                        margin-left: 16px;
                        width:95px;
                        height: 95px;
                        padding: 4px;
                        border:1px solid #CFD7E0;
                        border-radius: 4px;
                        position: relative;
                        img{
                            width:87px;
                            height: 87px;
                        }
                        img.place_order_right_card_form_imgList_img_icon1{
                            width:24px;
                            height: 24px;
                            position: absolute;
                            right: 0;
                            top:0;
                            cursor: pointer;
                        }
                    }
                    
                }
                &_title{
                    font-size: 18px;
                    color:#333333;
                    font-weight: 400;
                    margin-top:16px;
                }
                &_num{
                    &_unit{
                        position: absolute;
                        right:46px;
                        top:4px;
                        color:#333;
                        font-size: 18px;
                        z-index: 1;
                    }

                    &_unit.place_order_right_card_form_num_lifang{
                        right:40px;
                    }
                }
                &_checkbox{
                    width:390px;
                }
                /deep/ .el-input-number{
                    line-height: 36px;
                }
                /deep/ &_num .el-input__inner{
                    height:36px;
                    font-size: 18px;
                    color:#333;
                }
                /deep/ .el-input-number__increase,/deep/ .el-input-number__decrease{
                    width:34px;
                    height: 34px;
                }
                /deep/ .el-input-number .el-input__inner{
                    padding-right: 70px;
                }
            }
            /deep/ .el-row{
                margin-top: 20px;
            }
        }
    }
    &_title.place_order_title_btn{
        padding: 9px 20px 5px 20px;
    }
    &_title{

        padding: 16px 20px 12px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #E1E1E1;
        div{
            font-size: 20px;
            line-height: 28px;
            font-weight: 500;
        }
    }
    /deep/ .place_order_right_card_total_btn{
        display: flex;
        justify-content: flex-end;
        margin-top:140px;
        padding-bottom: 40px;
        .el-button{
            height: 46px;
            font-size: 24px;
            font-weight: 600;
        }
    } 

}
</style>



// WEBPACK FOOTER //
// src/pages/order/placeOrder.vue